import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["options", "instructions", "preview"]

  declare readonly optionsTarget: HTMLElement
  declare readonly hasInstructionsTarget: boolean
  declare readonly instructionsTarget: HTMLElement
  declare readonly hasPreviewTarget: boolean
  declare readonly previewTarget: HTMLElement

  connect() {
    this.toggle()
  }

  toggle() {
    const select = this.element.querySelector('select') as HTMLSelectElement
    const isMultipleChoice = ['radio', 'checkbox', 'select'].includes(select.value)
    const isInstructions = select.value === 'instructions'

    this.setVisible(this.optionsTarget, isMultipleChoice)

    if (this.hasInstructionsTarget) {
      this.setVisible(this.instructionsTarget, isInstructions)
    }

    if (this.hasPreviewTarget) {
      this.setVisible(this.previewTarget, !isMultipleChoice && !isInstructions)
    }
  }

  private setVisible(target: HTMLElement, visible: boolean) {
    target.hidden = !visible
    target.setAttribute("aria-hidden", String(!visible))
  }
}